// extracted by mini-css-extract-plugin
export default {"home":"SubScripe_home__Ong+Y","home2":"SubScripe_home2__BaQjk","main":"SubScripe_main__k1o64"};